export const formatNumberToCurrency = ({ value, currency = 'BGN' }: { value: number; currency?: 'BGN' | 'EUR' }) =>
  new Intl.NumberFormat('bg-BG', { currency, style: 'currency' }).format(value);
